import * as React from 'react';
import moment from 'moment';
import { GiCalendar } from "react-icons/gi";

import { MEDIA_BASE_URL } from '../../../config/constants';
import { StyledCard, Content, Row } from './CourseInfo.styles';
import lessonIcon from '../../../assets/images/lesson_icon_generic.png';
import { courseScoreColor } from 'src/common/services';


interface IProps {
  data?: any;
  isTeacher?: boolean;
  isSchool?: boolean;
}

class CourseInfo extends React.Component<IProps> {
  public state = {};

  constructor(props) {
    super(props);
  }

  public renderCourseInfo() {
    const {data} = this.props;
     const {
       Completion,
      Thumbnail,
      LastAttempt,
      AverageScore,
    } = data;


    return (
      <StyledCard>
        <img src={`${MEDIA_BASE_URL}${Thumbnail}`} alt="lesson icon" />
        <Content>
          <Row>
            <h3>Your Last Attempt</h3>
            <p>
              <GiCalendar size="36px" color="#3ee9f7" />
              {moment(LastAttempt).format("lll")}
            </p>
          </Row>
          <Row>
            <h3>Completion</h3>
            <p className="yellow">{Completion}%</p>
          </Row>
          <Row>
            <h3>Average course progress</h3>
            <p style={{ color: courseScoreColor(Math.round(AverageScore)) }}>
              {Math.round(AverageScore)}%
            </p>
          </Row>
        </Content>
      </StyledCard>
    );
  }

  public renderTeacherCourseInfo() {
    // const Thumbnail = 'https://staging.plex.coach/assets/course_thumbnail.png'
    const { data } = this.props;
    console.log({"teacherData": data})
    const { last_attempt, total_allocations, completed_allocations, avg_score, lessons_completed } = data;
    return (
      <StyledCard>
        <img src={lessonIcon} alt="lesson icon" />
        <Content>
          <Row>
            <h3>No. of pathways completed</h3>
            <p className="yellow">{lessons_completed}</p>
          </Row>
          <Row>
            <h3>No. of completed courses</h3>
            <p className="yellow">{completed_allocations}</p>
          </Row>
          <Row>
            <h3>Average course progress</h3>
            <p style={{ color: courseScoreColor(Math.round(avg_score)) }}>
              {Math.round(avg_score)}%
            </p>
          </Row>
        </Content>
      </StyledCard>
    );
  }

  public render() {
    const { data, isTeacher, isSchool } = this.props;
    // const lastAttempt = new Date('7-22-2019');
    if(isTeacher || isSchool) { return this.renderTeacherCourseInfo()}
   else { return this.renderCourseInfo()}
  }
}

export default CourseInfo;



// WEBPACK FOOTER //
// ./src/components/DataCentre/CourseInfo/CourseInfo.tsx